<template>
  <section class="listing">
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <form v-else @submit.prevent class="form" style="padding: 0">
        <!-- Sobre -->
        <div class="header">
          <div class="title">Sobre</div>
          <button @click="update = true" class="button-new"><i class="fas fa-pen"></i><span>ALTERAR</span></button>
        </div>
        <div class="row-settings">
          <div class="column-settings-2">
            <label>Nome</label>
            <input v-model="data.business.name" disabled />
          </div>
          <div class="column-settings-2">
            <label>Razão Social</label>
            <input v-model="data.business.nameReal" disabled />
          </div>
        </div>
        <div class="row-settings">
          <div class="column-settings-2">
            <label>CNPJ</label>
            <input v-model="data.business.regDocument" disabled />
          </div>
          <div class="column-settings-2">
            <label>Inscrição Estadual</label>
            <input v-model="data.business.regNumber" disabled />
          </div>
        </div>
        <div class="row-settings">
          <div class="column-settings-2">
            <label>Inscrição Municipal</label>
            <input v-model="data.business.regMunicipalNumber" disabled />
          </div>
          <div class="column-settings-2">
            <label>Simples Nacional</label>
            <input :value="data.business.regNumber ? 'Sim' : 'Não'" disabled />
          </div>
        </div>
        <!-- Localização -->
        <div class="divider"></div>
        <div class="header">
          <div class="title">Localização</div>
        </div>
        <div class="row-settings">
          <div class="column-settings-2">
            <label>CEP</label>
            <input v-model="data.business.addressPostcode" disabled />
          </div>
          <div class="column-settings-2">
            <label>UF</label>
            <input v-model="data.business.addressState" disabled />
          </div>
        </div>
        <div class="row-settings">
          <div class="column-settings-2">
            <label>Cidade</label>
            <input v-model="data.business.addressCity" disabled />
          </div>
          <div class="column-settings-2">
            <label>Bairro</label>
            <input v-model="data.business.addressSuburb" disabled />
          </div>
        </div>
        <div class="row-settings">
          <div class="column-settings-2">
            <label>Rua</label>
            <input v-model="data.business.addressStreet" disabled />
          </div>
          <div class="column-settings-2">
            <label>Número</label>
            <input v-model="data.business.addressNumber" disabled />
          </div>
        </div>
        <!-- Site -->
        <div class="divider"></div>
        <div class="header">
          <div class="title">Site</div>
        </div>
        <div class="row-settings">
          <div class="column-settings-2">
            <label>URL</label>
            <input v-model="data.business.url" disabled />
          </div>
        </div>
        <div class="row-settings">
          <div class="column-settings">
            <label>Sobre</label>
            <textarea v-model="data.business.about" rows="6" disabled></textarea>
          </div>
        </div>
        <!-- Contatos -->
        <div class="divider"></div>
        <div class="header">
          <div class="title">Contatos</div>
        </div>
        <table class="table">
          <tr v-for="contact in data.contacts" :key="contact.id">
            <td>{{ contact.name }}</td>
            <td>{{ contact.phone }}</td>
            <td>{{ contact.email }}</td>
            <td>{{ contact.role }}</td>
          </tr>
        </table>
        <!-- Faturamento -->
        <div class="divider"></div>
        <div class="header">
          <div class="title">Faturamento</div>
        </div>
        <div>
          <div class="row-settings">
            <div class="column-settings-2">
              <label>Taxa de Conveniência (%)</label>
              <input v-model="data.payment.commission" disabled />
            </div>
            <div class="column-settings-2">
              <label class="switch" style="display: flex; margin-top: 20px">
                <input v-model="data.payment.split" type="checkbox" disabled style="width: auto">
                <span class="slider"></span>
                <span class="text">Split dos recebíveis</span>
              </label>
            </div>
          </div>
          <div class="row-settings">
            <div class="column-settings-2">
              <label>Banco</label>
              <input v-model="data.payment.bank" disabled />
            </div>
            <div class="column-settings-2">
              <label>Tipo de Conta</label>
              <select v-model="data.payment.bankAccountType" disabled style="width: 100%">
                <option value="corrente">Conta Corrente</option>
                <option value="poupanca">Conta Poupança</option>
              </select>
            </div>
          </div>
          <div class="row-settings">
            <div class="column-settings-2">
              <label>Agência</label>
              <input v-model="data.payment.bankBranch" type="text" disabled />
            </div>
            <div class="column-settings-2">
              <label>Conta</label>
              <input v-model="data.payment.bankAccount" type="text" disabled />
            </div>
          </div>
        </div>
      </form>
    </transition>
    <InfoUpdate v-if="update" :close="() => this.update = false" />
  </section>
</template>

<script>
import logger from '../../logger'
import { get } from '../api/business'
import InfoUpdate from './InfoUpdate.vue'

export default {
  name: 'info',
  components: { InfoUpdate },
  data () {
    return {
      loading: true,
      data: null,
      update: false
    }
  },
  async mounted () {
    try {
      this.data = await get()
    } catch (error) {
      logger.error(error, this)
    }
    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables.scss";

.row-settings {
  display: flex;
  flex-wrap: wrap;

  label, input, textarea {
    display: block;
  }
  input, textarea {
    width: 100%;
  }
}

.column-settings, .column-settings-2, .column-settings-3 {
  flex-basis: calc(100% - 10px);
  margin: 10px 5px;
}

.divider {
  border-top: 1px solid #ddd;
  margin: 25px 0 20px;
}

.table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ccc;

  th, td {
    padding: 8px 10px;
    font-weight: 400;
  }

  tr {
    font-size: 1em;
    color: #555;

    &:nth-child(2n+1) {
      background-color: #e5e5e5;
    }
  }
}

@media screen and (min-width: $desktop-width) {

  .column-settings-2 {
    flex-basis: calc(50% - 10px);
  }

  .column-settings-3 {
    flex-basis: calc(33% - 10px);
  }

}
</style>
